import React from "react";
import { Upload, Icon, Modal } from 'antd';
import css from './index.css';
import createUuid from '../../../utils/createUuid';
const baseUrl = "api/zhxg-yxwz/"

class PictureUpload extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            previewVisible: false,  // 是否显示预览页
            previewImage: '',  // 预览图片地址
            fileList: [], // 文件列表
        };
    }

    componentDidMount() {
        let { xsid } = this.props;
        if (!xsid) return; // xsid为空时不加载图片
        let fileList = []
        let file = {}
        let path = "openapi/yxwz/queryQr?xsid=" + xsid + "&" + createUuid();
        
        file.uid = -1;
        file.name = xsid + "-班级群图.png";
        file.status = 'done';
        file.url = baseUrl + path;
        fileList.push(file)
        this.setState({fileList})
    }

    handleCancel = () => this.setState({ previewVisible: false })
    
    handlePreview = (file) => {
    this.setState({
        previewImage: file.url || file.thumbUrl,
        previewVisible: true,
    });
    }

    handleChange = ({ fileList }) => {
        if (fileList && fileList.length > 0 && fileList[0].status == 'done') {
            // 可以获取到uuid
            this.props.handleBjqmId(fileList[0].response.data);
        }
        this.setState({ fileList })
        
    }

    handleRemove = (file) => {
        // 可以获取移除的uuid
        this.props.handleBjqmId("-1");
    }

    render() {
        const { previewVisible, previewImage, fileList } = this.state;
        const { disableDelete } = this.props;
        const uploadButton = (
          <div>
            <Icon type="plus" />
            <div className={css.ant_upload_text}>Upload</div>
          </div>
        );
        return (
        <div className={css.clearfix}>
            <div>
                <Upload
                //   action="//jsonplaceholder.typicode.com/posts/"
                action={baseUrl + "/bjqqgl/uploadTempFile"}
                listType="picture-card"
                fileList={fileList}
                onPreview={this.handlePreview}
                onChange={this.handleChange}
                onRemove={this.handleRemove}
                disabled={disableDelete}
                >
                {fileList.length >= 1 ? null : uploadButton}
                </Upload>
                <Modal visible={previewVisible} footer={null} onCancel={this.handleCancel}>
                    <img alt="example" style={{ width: '100%' }} src={previewImage} />
                </Modal>
            </div>
          </div>  
        );
    }
}
export default PictureUpload;
